import { FormField } from "components/Forms/FormField";
import { LynePeoplePicker } from "components/Lyne/LynePeoplePicker";
import { UserLookupModel } from "models/UserLookupModel";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface HookFormPeoplePickerProps<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
> extends FormField {
  name: TName;
  control: Control<TFieldValues, unknown, TFieldValues>;
}

export const HookFormPeoplePicker = <TFieldValues extends FieldValues, TName extends Path<TFieldValues>>(
  props: HookFormPeoplePickerProps<TFieldValues, TName>
) => {
  const { name, control, required, label, contextHelp } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field, fieldState }) => {
        const { error } = fieldState;
        const { onChange, value, disabled } = field;
        const nameToUse = `hookform-${name}`;

        return (
          <LynePeoplePicker
            name={nameToUse}
            label={label}
            disabled={disabled}
            onChange={(user: UserLookupModel | undefined) => {
              onChange(user);
            }}
            currentUser={value}
            contextHelp={contextHelp}
            error={error?.message}
          />
        );
      }}
    />
  );
};
